<div class="custom-input radio" [ngClass]="customClasses">
  <label class="input-item" [attr.for]="id" (click)="onLabelClick($event)">
    <input
      type="radio"
      [name]="name"
      [value]="value"
      [id]="id"
      [checked]="valueModel === value"
      [disabled]="disabled"
      (change)="onRadioChange($event)"
    />
    <span class="checkmark"></span>
    <span class="label-text" [innerHTML]="label"></span>
  </label>
</div>